// src/Firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// الإعدادات الجديدة كلياً (التي تنتهي بـ 12cbd)
const firebaseConfig = {
  apiKey: "AIzaSyCIBTz6bIpqjvHygEB3tmiL6NqYkC4dCns",
  authDomain: "aslofrem-stock.firebaseapp.com",
  projectId: "aslofrem-stock",
  storageBucket: "aslofrem-stock.firebasestorage.app",
  messagingSenderId: "262715796981",
  appId: "1:262715796981:web:12cbd38d2c9070ba1f44bc", // تم التحديث هنا
  measurementId: "G-5MTVG3N3F5" // تم التحديث هنا
};

// تهيئة Firebase
const app = initializeApp(firebaseConfig);

// تصدير الخدمات
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export const firebaseApp = app;

export default app;
